define('core/analytics/identity',[
    'exports',

    'core/utils/cookies',
    'core/utils/guid',
    'core/utils/hash',
    'core/utils/fingerprint',
], function (
    exports,

    cookies,
    guid,
    hash,
    fingerprint
) {
    'use strict';

    var initialized = false;

    var ImpressionManager = exports.ImpressionManager = function () {
        // Will be updated by calls made from individual app initializations. Defaults to true to be safe
        this.isPrivate = true;

        this.impId = guid.generate();
    };
    ImpressionManager.prototype.COOKIE_NAME = '__jid';  // jid is 'jester impression id'
    ImpressionManager.prototype.TTL = 30 * 60 * 1000;  // TTL for the impression cookie is 30 minutes
    ImpressionManager.prototype.init = function (options) {
        // This function should be called upon app initialization, before this manager's values
        // or functions are utilized

        this.isPrivate = options && options.isPrivate;

        if (!this.isPrivate)
            this.prevImp = cookies.read(this.COOKIE_NAME);

        this.persist();
    };
    ImpressionManager.prototype.setImpressionId = function (impId) {
        this.impId = impId;
        this.persist();
    };
    ImpressionManager.prototype.persist = function () {
        // TODO: This is getting wiped if we find out `isPrivate` is actually
        // false later since it is initialized before the session is fetched
        // which can influence `isPrivate`.
        if (this.isPrivate) {
            cookies.erase(this.COOKIE_NAME);
            return;
        }

        // Set cookie so the current impression id
        // can be grabbed as the previous impression id in the next invocation.
        // (Expires after 30 minutes of inactivity.)
        cookies.create(this.COOKIE_NAME, this.impId, { expiresIn: this.TTL });
    };


    var UniqueManager = exports.UniqueManager = function () {
        // Will be updated by calls made from individual app initializations. Defaults to true to be safe
        this.isPrivate = true;
    };
    UniqueManager.prototype.COOKIE_NAME = 'disqus_unique';
    UniqueManager.prototype.TTL = 365 * 24 * 60 * 60 * 1000;  /* one year in ms */
    UniqueManager.prototype.init = function (options) {
        // This function should be called upon app initialization, before this manager's values
        // or functions are utilized
        this.isPrivate = options && options.isPrivate;

        if (this.isPrivate) {
            cookies.erase(this.COOKIE_NAME, {
                domain: window.location.host.split(':')[0],
            });
            return;
        }

        // TODO: We are currently generating a new GUID each time we ever
        // initialize with `isPrivate` which is the default behavior.  We
        // could persist the GUID in localStorage so we can use it whenever
        // we have consent and still keep deleting our cookie, or we can
        // decide we don't need to delete our cookie anymore, but we will
        // need to get legal's approval on which approach we are comfortable
        // with.  A version of the latter (storing in localStorage) can be
        // found in an early version of D28850.
        this.value = cookies.read(this.COOKIE_NAME) || guid.generate();

        // This needs to be called each time because if we ever
        // change the options, existing cookies will not get updated.
        cookies.create(this.COOKIE_NAME, this.value, {
            domain: window.location.host.split(':')[0],
            expiresIn: this.TTL,
        });
    };
    UniqueManager.prototype.isPersistent = function () {
        // If we were not able to set and read a cookie
        // then the browser does not support cookies.
        return !this.isPrivate && cookies.read(this.COOKIE_NAME) === this.value;
    };

    exports.init = function (options, force) {
        if (initialized && !force)
            return;

        exports.impression.init(options);
        exports.unique.init(options);
        initialized = true;
    };

    exports.reset = function () {
        initialized = false;

        exports.impression = new ImpressionManager();
        exports.unique = new UniqueManager();
    };

    exports.reset();

    /**
     * Returns a consistent ID for this client.
     *
     * Uses either the disqus_unique cookie value or the
     * browser's fingerprint value if cookies are not supported.
     * @returns {string} client id
     */
    exports.clientId = function () {
        var manager = exports.unique;
        var value;

        if (manager.isPersistent())
            value = manager.value;

        return value || fingerprint.get().toString();
    };

    /**
     * Returns a number between 0..99 for a given string identifier.
     *
     * This method of determining a percent using a specific string identifier
     * (such as a forum shortname, username, disqus_unique id, etc.)
     *
     * https://blog.disqus.com/the-paper-plane-proof-our-uplifting-story-of-client-side-javascript-bucketing
     *
     * @param {string} str - String to get calculated into a percent bucket
     * @returns {number} Number that is calculated from the hashed input
     */
    exports.getPercentBucketForString = function (str) {
        return Math.abs(hash.calculate(str) % 100);
    };

    /**
     * Calculates the percentile for the client ID.
     *
     * @returns {number} percentile - Number that is calculated from the hashed input
     */

    exports.clientPercent = function () {
        return exports.getPercentBucketForString(exports.clientId());
    };
});

